"use strict";

angular
    .module("harriApp")
    .service("careerStoryPageService", CareerStoryPageService);

CareerStoryPageService.$inject = [];

function CareerStoryPageService() {
    let self = this;
    let careerStoryPageData = {};
    self.MiddleSectionTypes = {
        TEXT_PLUS_MEDIA: "TEXT_PLUS_MEDIA",
        MEDIA_PLUS_TEXT: "MEDIA_PLUS_TEXT",
        SIX_POINTS: "SIX_POINTS",
        IMAGE_COLLAGE: "IMAGE_COLLAGE",
        TEXT_PLUS_LARGE_MEDIA: "TEXT_PLUS_LARGE_MEDIA",
        LARGE_MEDIA_WITHOUT_TEXT: "LARGE_MEDIA_WITHOUT_TEXT",
    };
    const DEFAULT_HERO_LOGO = '../images/logos/harri/blue/harri-icon.svg';
    const DEFAULT_FOOTER_BACKGROUND = '#000000';
    const DEFAULT_SIX_POINTS_SECTION_ICON = 'fa fa-star';

    self.setCareerStoryPageData = (data) => {
        careerStoryPageData = data;
    }

    self.getCareerStoryPageData = () => {
        return self.parseCareerStoryPageData(careerStoryPageData);
    }

    self.ensureHttps = (url) => {
        if (!url) {
            return url;
        }
        return url.startsWith('https://') ? url : 'https://' + url;
    }

    self.encodeImageUrl = (url) => {
        if (url?.includes(' ')) {
            return encodeURI(url);
        } else {
            return url;
        }
    }

    const makeEmbedVideoLink = (url) => {
        if (url.includes('youtube')) {
         if (url.includes('watch?v=')) {
             const videoId = url.split('watch?v=')[1];
             return `https://www.youtube.com/embed/${videoId}`;
         }
         return url;
        } else if (url.includes('vimeo')) {
            const urlParts = url.split('/');
            const videoId = urlParts[urlParts.length - 1];
            return `https://player.vimeo.com/video/${videoId}`
        }
    }

    self.parseCareerStoryPageData = (data) => {
        if (data.hero_section.media_type === 'CAROUSEL') {
            if (data.hero_section.carousel?.length) {
                data.hero_section.carousel = data.hero_section.carousel.sort((image1, image2)=> image1.display_order >= image2.display_order);
            } else {
                data.hero_section.media_type = 'IMAGE';
                data.hero_section.image = null;
            }
        } else if (data.hero_section.media_type !== 'VIDEO' || (data.hero_section.media_type === 'VIDEO' && !data.hero_section.video?.video_href)) {
            data.hero_section.media_type = 'IMAGE';
            data.hero_section.image = self.encodeImageUrl(data.hero_section.hero_image_href) || null;
        }
        data.hero_section.logo_href = self.encodeImageUrl(data.hero_section.logo_href) || DEFAULT_HERO_LOGO;
        data.footer_section.background_color = data.footer_section.background_color || DEFAULT_FOOTER_BACKGROUND;

        if (data.footer_section.links) {
            Object.keys(data.footer_section.links).forEach(key => {
                if (data.footer_section.links[key].url) {
                    data.footer_section.links[key].url = self.ensureHttps(data.footer_section.links[key].url);
                }
            });
        }
        let parsedData = {
            font: cspFontFamilyUtils.getFont(cspFontFamilyUtils.fonts, data.font_name),
            hero_section: data.hero_section,
            footer_section: data.footer_section,
            middle_section: [],
            social_links: data.social_links
        };

        let sortedMiddleSection = data.middle_section.sort((section1, section2) => section1.rank - section2.rank);

        sortedMiddleSection.forEach(middleSection => {
            let parsedMiddleSection = {
                color: middleSection.color,
                name: middleSection.name,
                visibility_on_header_navigation: middleSection.visibility_on_header_navigation,
                template_code: middleSection.template_code,
                fields: [],
                rank: middleSection.rank,
            };

            let sortedMiddleFields = middleSection.fields.sort((field1, field2) => field1.rank - field2.rank);

            switch (middleSection.template_code) {
                case self.MiddleSectionTypes.TEXT_PLUS_MEDIA:
                case self.MiddleSectionTypes.MEDIA_PLUS_TEXT:
                case self.MiddleSectionTypes.TEXT_PLUS_LARGE_MEDIA:
                case self.MiddleSectionTypes.LARGE_MEDIA_WITHOUT_TEXT:
                    sortedMiddleFields.forEach(field => {
                        switch (field.code) {
                            case 'MAIN_TITLE':
                                parsedMiddleSection.main_title = field.value;
                                break;
                            case 'MAIN_DESCRIPTION':
                                parsedMiddleSection.description = field.value;
                                break;
                            case 'IMAGE':
                                parsedMiddleSection.img_href = self.encodeImageUrl(field.href);
                                break;
                            case 'VIDEO':
                                parsedMiddleSection.video_href = field.value.video_href;
                                parsedMiddleSection.thumbnail_href = field.value.thumbnail_href;
                                parsedMiddleSection.is_hosted = field.value.is_hosted;
                                if (field.value.is_hosted) {
                                    parsedMiddleSection.video_href = makeEmbedVideoLink(parsedMiddleSection.video_href);
                                }
                                break;
                            case 'CAROUSEL':
                                parsedMiddleSection.carousel = field.value.sort((image1, image2)=> image1.display_order >= image2.display_order);
                                break;
                        }
                    });
                    break;

                case self.MiddleSectionTypes.SIX_POINTS:
                    const excludedFields = ['MAIN_TITLE', 'MAIN_DESCRIPTION'];
                    sortedMiddleFields.forEach(field => {
                        if (excludedFields.includes(field.code)) {
                            if (field.code === 'MAIN_TITLE') {
                                parsedMiddleSection.main_title = field.value;
                            } else if (field.code === 'MAIN_DESCRIPTION') {
                                parsedMiddleSection.description = field.value;
                            }
                        } else {
                            const pointMatch = field.code.match(/^POINT_(TITLE|DESCRIPTION)_(\d+)$/);
                            if (pointMatch) {
                                const [, type, index] = pointMatch;
                                const parsedField = parsedMiddleSection.fields[index - 1] || {};
                                if (type === 'TITLE') {
                                    parsedField.title = field.value;
                                    parsedField.icon = field.icon_code || DEFAULT_SIX_POINTS_SECTION_ICON;
                                } else if (type === 'DESCRIPTION') {
                                    parsedField.description = field.value;
                                }
                                parsedMiddleSection.fields[index - 1] = parsedField;
                            }
                        }
                    });
                    break;

                case self.MiddleSectionTypes.IMAGE_COLLAGE:
                    sortedMiddleFields.forEach(field => {
                        let parsedImageField = {
                            img_href: self.encodeImageUrl(field.href),
                            value: field.value
                        };
                        if (field.href) {
                            parsedMiddleSection.fields.push(parsedImageField);
                        }
                    });
                    break;
            }

            parsedData.middle_section.push(parsedMiddleSection);
        });

        return parsedData;
    }

}